


















import {
  Vue, Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { IUserProfile } from '../../../shared/models';
import InfoEditor from '../../../shared/components/InfoEditor.vue';
import { api } from '../../../services/index';
import { user } from '../../../store/user/index';

@Component({
  name: 'SubActionBar',
})
export default class SubActionBar extends Vue {
  editorOption = {
    errorMessage: 'Đang trong tiến trình chỉnh sửa thông tin user khác',
    blankText: 'Chọn user để xem thông tin',
    confirmEdit: 'Sửa thông tin user này',
  };

  @Prop() private userId!: number | null;

  @Prop() private totalUser!: number;

  private userDetail: IUserProfile | null = null;

  private currentTab = 'summary';

  private isLoading = false;

  @Emit('clearSelection')
  protected clear() {}

  @Watch('userId', { immediate: true })
  async onUserIdChange(value: any) {
    if (!value) {
      this.userDetail = null;
    } else {
      this.isLoading = true;
      this.currentTab = 'detail';
      this.userDetail = await this.$api.users.getUser(value);
      this.isLoading = false;
    }
  }

  async handleUpdateUser(value: any) {
    try {
      await this.$api.users.updateUser(this.userId, value);
      this.$notify.success(
        `Cập nhật thông tin user ${this.userId} thành công!`,
      );
      this.$emit('refetch');
    } catch (e) {
      this.$notify.error(`Đã xảy ra lỗi: ${e.error}`);
    }
  }
}
